import type { Finding, OverviewItem } from '../api-types';

export const HOTSPOT_LIMIT = 8;

export interface DriveChildren {
  readonly drive: OverviewItem;
  readonly items: readonly OverviewItem[];
}

export interface Hotspot {
  readonly folder: OverviewItem;
  readonly drive: OverviewItem;
  readonly toFix: number;
}

const toFixOf = (item: OverviewItem) =>
  item.progress === undefined ? 0 : item.progress.total - item.progress.inLine;

/** The drives' folders with the most left to fix, most first, at most 8; none with 0. */
export function hotspotsOf(lists: readonly DriveChildren[]): Hotspot[] {
  return lists
    .flatMap(({ drive, items }) =>
      items
        .filter((item) => item.kind === 'folder')
        .map((folder) => ({ folder, drive, toFix: toFixOf(folder) })),
    )
    .filter((row) => row.toFix > 0)
    .sort((a, b) => b.toFix - a.toFix)
    .slice(0, HOTSPOT_LIMIT);
}

/** How many findings of each kind, most first; a kind with none is not listed. */
export function kindCounts(findings: readonly Finding[]): { kind: string; count: number }[] {
  const counts = new Map<string, number>();
  for (const finding of findings) counts.set(finding.kind, (counts.get(finding.kind) ?? 0) + 1);
  return [...counts].map(([kind, count]) => ({ kind, count })).sort((a, b) => b.count - a.count);
}
